import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { CloseButton, Col, Container, Image, Row, Spinner, Tab, Tabs, Table  } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import Category from './Category';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import * as RIcon from "react-icons/fa"
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CardRegist from './common/CardRegist';
import { Alert, Button, Card, CardContent, CardHeader, CardMedia, Chip, Typography } from '@mui/material';
import ApiFetch from './ApiFetch';
import CommonDialog from './common/CommonDialog';
import LoadingButton from '@mui/lab/LoadingButton';
import DirectdebitRegist from './common/DirectdebitRegist';
import Constants from './common/Constants';
import ChargeDirectdebitRegist from './common/ChargeDirectdebitRegist';
import SettingPopup from './SettingPopup';

const GenerateUnlimit = () => {
    const {t,i18n} = useTranslation()
    const navigate = useNavigate()
    // 設定
    const [showSetting,setShowSetting] = useState(false)
    return(
    <div className="wrapper" style={{backgroundColor:"#EEEEEE",borderRadius:"10px"}}>
        {showSetting ? (<SettingPopup switch={setShowSetting} />) : ""}
        <header className="App-header"></header>
        <Header />
        <Category />
        <Container className='w-100 p-3' style={{backgroundColor:"#FFFFFF"}}>
            <p style={{fontSize:"24px"}}>画像生成機能の制限解除について</p>
            通常の生成機能では、NGワードが多く設定されておりますが、いくつかの方法で<br />
            NGワードのない状態で生成することができるようになります。<br />
            ・コイン決済を使用する<br />
            ・年齢認証を行う。<br />
            ※一部のプロンプトについては自動修正される場合があります。<br /><br />
            <h5>コイン決済の利用</h5><br />
            <h5>1.</h5>
            <ul>
                <li><Link to={"/coin"}>コインを購入</Link>する</li>
                <li><Link to={"/legal"}>プラン画面</Link>でプレミアムまたはプレミアムプラスプランをコイン支払いで登録</li>
            </ul>
            <Image src='/img/unlimit/plan.png' /><br /><br />
            <h5>2.</h5>
            <ul>
                <li><Link to={"/coin"}>コインを購入</Link>する</li>
                <li><Link to={"/upload/image/generata"}>生成画面</Link>でコイン支払いを選択する</li>
            </ul>
            <Image src='/img/unlimit/select.png' /><br />
            <Button style={{fontSize:"20px"}} className='m-3' onClick={() => navigate('/coin')} variant='outlined'>コインを購入</Button>
            <Button style={{fontSize:"20px"}} className='m-3' onClick={() => navigate('/upload/image/generate')} variant='outlined'>生成画面へ</Button><br /><br />
            <h5>年齢認証を行う</h5><br />
            SMS認証と身分証確認を行うことで、生成画面の「フル版」にチェックを入れると、制限解除されます。<br />
            ※チェックを入れている間はサブスクの特典が利用できず、ポイント消費されます。<br />
            <Button style={{fontSize:"20px"}} className='m-3' onClick={() => setShowSetting(true)} variant='outlined'>設定</Button><br /><br />
            <h5 className='mt-3'>その他</h5>
            <ul>
                <li>登録年齢が18歳未満の場合は制限解除されません。</li>
                <li>サブスクの場合はプレミアム、プレミアムプラスが制限解除の対象です。</li>
                <li>利用規約を遵守してください。</li>
                <li>対象外モデル：DALL-E3、Stable Diffusion 3、Stable Diffusion 3 Turbo、Stable Image Ultra、FLUX.1 schnell</li>
            </ul>
        </Container>
        <Footer />
    </div>
    )
}

export default GenerateUnlimit;
